import { render, staticRenderFns } from "./PageCashCouponRemain.vue?vue&type=template&id=efcf368e&scoped=true"
import script from "./PageCashCouponRemain.vue?vue&type=script&lang=js"
export * from "./PageCashCouponRemain.vue?vue&type=script&lang=js"
import style0 from "./PageCashCouponRemain.vue?vue&type=style&index=0&id=efcf368e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcf368e",
  null
  
)

export default component.exports